import React from "react";
import { Reveal } from "../Reveal";

const steps = [
  {
    n: "01",
    title: "Upload",
    body: "The artist or designer uploads authorised artwork. Every file starts its life with a name attached to it.",
  },
  {
    n: "02",
    title: "Approve",
    body: "Nothing ships without the artist's explicit sign-off. Approval is the gate — not an afterthought.",
  },
  {
    n: "03",
    title: "Customise",
    body: "Fans personalise garments within the artist's rules, or propose their own ideas back to the studio.",
  },
  {
    n: "04",
    title: "Fulfil",
    body: "Printed on demand and shipped worldwide. Zero inventory, zero waste, zero upfront risk.",
  },
];

export const HowItWorks = () => {
  return (
    <section id="how" data-testid="how-section" className="relative py-28 md:py-40" style={{ backgroundColor: "#0E0A16" }}>
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal>
          <div className="flex items-end justify-between flex-wrap gap-6 mb-16 md:mb-24">
            <div>
              <div className="font-inter font-light text-[11px] uppercase tracking-[0.28em] mb-5" style={{ color: "#9B8FAC" }}>
                How it works
              </div>
              <h2 className="font-inter font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.15]" style={{ color: "#F4EEF7", letterSpacing: "-0.01em" }}>
                Four steps.<br />No compromises.
              </h2>
            </div>
            <p className="font-inter font-light max-w-[34ch] text-base leading-relaxed" style={{ color: "#9B8FAC" }}>
              A build order designed so the person who made the art keeps the final say — from upload to doorstep.
            </p>
          </div>
        </Reveal>

        <div className="divide-y" style={{ borderColor: "#2A2233" }}>
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.06}>
              <div
                className="group relative grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-10 md:py-14 border-t"
                style={{ borderColor: "#2A2233" }}
                data-testid={`how-step-${s.n}`}
              >
                {/* Giant faint number */}
                <div
                  aria-hidden="true"
                  className="pointer-events-none absolute right-0 top-1/2 -translate-y-1/2 font-display font-black leading-none select-none text-[22vw] md:text-[10vw] transition-colors duration-500"
                  style={{ color: "#171021" }}
                >
                  {s.n}
                </div>
                <div className="md:col-span-2 font-display text-2xl md:text-3xl" style={{ color: "#C724B1" }}>
                  {s.n}
                </div>
                <h3 className="md:col-span-3 relative z-10 font-display text-3xl md:text-4xl group-hover:translate-x-2 transition-transform duration-500" style={{ color: "#F4EEF7" }}>
                  {s.title}
                </h3>
                <p className="md:col-span-5 relative z-10 text-base md:text-lg leading-relaxed max-w-[46ch]" style={{ color: "#9B8FAC" }}>
                  {s.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
